// removed by extract-text-webpack-plugin
module.exports = {"vadpLoginForHXYY_ZHYYGLXT":"vadpLoginForHXYY_ZHYYGLXT___xL5Vw","pic":"pic___2CE8B","container":"container___13ua0","title":"title___3itTT","autofill-fix":"autofill-fix___kNqOh","vadpLogin":"vadpLogin___2fgV4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForHXYY_ZHYYGLXT/index.less
// module id = 350
// module chunks = 0